import { cn } from "@/shared/lib/utils"
import BallImage from "../assets/ball.webp"

type ScenarioBallProps = {
	size: "sm" | "md"
	filled?: boolean
	className?: string
}

export function ScenarioBall({ size, filled, className }: ScenarioBallProps) {
	return (
		<span
			className={cn(
				"flex shrink-0 items-center justify-center rounded-full",
				size === "md" ? "size-6" : "size-3",
				className,
			)}
		>
			{filled && (
				<img
					src={BallImage}
					alt=""
					className={size === "md" ? "size-5" : "size-2.5"}
				/>
			)}
		</span>
	)
}
